import { paths } from "~/router/paths";

export const excludePaths: string[] = [
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
  paths.checkout.index,
  paths.settings.index,
  paths.checkout.index.replace(":id", "")
];

export const notLoggedInPaths: string[] = [
  paths.app.home_login,
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
  paths.checkout.index.replace(":id", ""),
  paths.settings.index,
];
